import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, inject } from '@angular/core';
import { FilterService } from 'libs/api/server-bo/src/lib/services/filter.service';

@Component({
  selector: 'app-list-table-header',
  templateUrl: './list-table-header.component.html',
  styleUrls: ['./list-table-header.component.scss'],
  standalone: false,
})
export class ListTableHeaderComponent implements OnInit {
  private filterService = inject(FilterService);
  @Input() column: any;
  sortState = { column: null, direction: 'asc' };

  isSorted = false;
  sortDirection: 'asc' | 'desc' = 'asc';

  ngOnInit(): void {
    this.filterService.currentSortedColumn$.subscribe(currentSortedColumn => {
      this.isSorted = currentSortedColumn === this.column.key;
    });
  }

  clearFilter(): void {
    this.filterService.removeFilterTerm(this.column.key); 
    this.column.filterValue = ''; 
  }
  
  onFilterChange(value: any) {
    this.filterService.setFilterTerm(this.column, value);
  }

  onSort() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.filterService.setCurrentSortedColumn(this.column.key); 
    this.filterService.setSortColumn(this.column.key);
    this.filterService.setSortDirection(this.sortDirection);
  }
}
